import {ShouldSkipLazyLoadType} from 'app/interface';

export function getLoadingType(results: Set<ShouldSkipLazyLoadType>): ShouldSkipLazyLoadType {
    if (results.has('LOAD_EAGER_WITH_SCROLL_TO')) {
        return 'LOAD_EAGER_WITH_SCROLL_TO';
    }

    if (results.has('LOAD_EAGER')) {
        return 'LOAD_EAGER';
    }

    return 'LOAD_LAZY';
}
